import {analytics} from '../globals/config';

export default function (step, stepNum, type = 'user-error', option = '', message = '') {
    const eventData = {
        event: 'tool-error',
        info: {
            toolType: 'request-form',
            toolName: 'wonderservice-quote',
            toolStep: step,
            leadID: '',
            requestType: 'quote',
            toolStepOption: option,
            toolStepNumber: stepNum,
            errorType: type,
            errorMessage: message,
        },
    };

    analytics.trackEvent(eventData);
}

